// Factory to ease injection for unit testing via jest module mocks.
export default function () {
  return new Audio()
}
